(function() {
	'use strict';
	angular.module('app.core')
		.service('tableFilterFunctionsService', tableFilterFunctionsService);

	tableFilterFunctionsService.$inject = ['$timeout', '$filter', '$translate', 'leanFilterService', 'storeService'];
	function tableFilterFunctionsService($timeout, $filter, $translate, leanFilterService, storeService) {
		var tempList = [];
		var tempComparator = '';
		var tempValueOne = '';
		var tempValueTwo = '';
		var tempString = '';
		var viewValues = {};
		resetViewValues();
		var applied = false;
		var comparators = leanFilterService.comparators;

		return {
			getViewValues: getViewValues,
			toggleAll: toggleAll,
			allVisibleSelected: allVisibleSelected,
			noneVisibleSelected: noneVisibleSelected,
			toggled: toggled,
			getApplied: getApplied,
			setApplied: setApplied,
			cancelSelection: cancelSelection,
			applySelectionInner: applySelectionInner,
			selectTopLevelFilter: selectTopLevelFilter,
			toggleItem: toggleItem,
			removeFilterInner: removeFilterInner,
			clearAllFiltersInner: clearAllFiltersInner,
			comparators: comparators,
			getFilteredModel: getFilteredModel,
			updateVisibleAllOrNone: updateVisibleAllOrNone,
			setDropdownMenuLocation: setDropdownMenuLocation,
			toggleMyItem: toggleMyItem,
			isReadOnly: isReadOnly,
			getNumberOfSaves: getNumberOfSaves,
			getReportAuthorizationLevel: getReportAuthorizationLevel,
			sortFilters: sortFilters
		};

		function setDropdownMenuLocation($event) {
			window.innerWidth - jQuery($event.target).offset().left > 200 ?
				jQuery($event.target).next().addClass('dropdown-menu-left').removeClass('dropdown-menu-right') :
				jQuery($event.target).next().addClass('dropdown-menu-right').removeClass('dropdown-menu-left');
		}

		function resetViewValues () {
			viewValues.numberSelected = 0;
			viewValues.allSelected = false;
			viewValues.noneSelected = false;
			viewValues.allVisibleSelected = false;
			viewValues.noneVisibleSelected = false;
			viewValues.visibleMenu = 'top';
		}

		function saveTempList(listToBackup) {
			tempList = jQuery.extend(true, [], listToBackup);
		}

		function saveTempComparisonValues(filterId) {
			tempComparator = leanFilterService.getComparator(filterId);
			tempValueOne = leanFilterService.getValueOne(filterId);
			tempValueTwo = leanFilterService.getValueTwo(filterId);
			if (leanFilterService.isCustomFilter(filterId)) {
				tempString = leanFilterService.getValue(filterId);
			}
		}

		function updateAllOrNone(list) {
			var allSelectedTemp = true;
			var noneSelectedTemp = true;
			viewValues.numberSelected = 0;
			angular.forEach(list, function(item) {
				if (item.selected) {
					viewValues.numberSelected += 1;
					noneSelectedTemp = false;
				} else if (!item.selected) {
					allSelectedTemp = false;
				}
			});

			viewValues.allSelected = allSelectedTemp;
			viewValues.noneSelected = noneSelectedTemp;
		}

		function updateVisibleAllOrNone(list) {
			var allSelectedTemp = true;
			var noneSelectedTemp = true;
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].selected) {
					noneSelectedTemp = false;
					break;
				}
			}
			for (i = 0; i < list.length; i++) {
				if (!list[i].selected) {
					allSelectedTemp = false;
					break;
				}
			}

			viewValues.allVisibleSelected = allSelectedTemp;
			viewValues.noneVisibleSelected = noneSelectedTemp;
		}

		function toggleAll(searchString) {
			var selVal = false;
			if (allVisibleSelected(searchString) || !noneVisibleSelected(searchString)) {
				viewValues.noneSelected = true;
				viewValues.allSelected = false;
				selVal = false;
			} else {
				viewValues.noneSelected = false;
				viewValues.allSelected = true;
				selVal = true;
			}

			var dropDownMenuList = leanFilterService.getList(viewValues.visibleMenu);
			var searchedMenu = getFilteredModel(dropDownMenuList, searchString);
			viewValues.numberSelected = 0;
			angular.forEach(searchedMenu, function(ig) {
				ig.selected = selVal;
			});

			angular.forEach(dropDownMenuList, function(it) {
				if (it.selected) {
					viewValues.numberSelected += 1;
				}
			});
		}

		function allVisibleSelected(searchString) {
			if (viewValues.visibleMenu && viewValues.visibleMenu !== 'top') {
				var type = leanFilterService.getTypeOfFilter(viewValues.visibleMenu);
				if (type === 'multiselect') {
					var dropDownMenuList = leanFilterService.getList(viewValues.visibleMenu);
					var searchedMenu = getFilteredModel(dropDownMenuList, searchString);
					var numberVisible = searchedMenu.length;
					var selectedCount = 0;
					angular.forEach(searchedMenu, function(mi) {
						if (mi.selected) {
							selectedCount++;
						}
					});
					return selectedCount === numberVisible;
				}
			}
			return false;
		}

		function noneVisibleSelected(searchString) {
			if (viewValues.visibleMenu && viewValues.visibleMenu !== 'top') {
				var type = leanFilterService.getTypeOfFilter(viewValues.visibleMenu);
				if (type === 'multiselect') {
					var dropDownMenuList = leanFilterService.getList(viewValues.visibleMenu);
					var searchedMenu = getFilteredModel(dropDownMenuList, searchString);
					for (var i = 0; i < searchedMenu.length; i++) {
						if (searchedMenu[i].selected) {
							return false;
						}
					}
					return true;
				}
			}
			return false;
		}

		function toggled(open, filter) {
			if (!open) {
				if (!applied) {
					cancelSelection();
				}
			} else if (filter) {
				$timeout(function() {
					applied = false;
					viewValues.visibleMenu = filter;
					var type = leanFilterService.getTypeOfFilter(filter);
					if (type === 'multiselect') {
						saveTempList(leanFilterService.getList(filter));
						var list = leanFilterService.getList(viewValues.visibleMenu);
						updateAllOrNone(list);
					} else if (type === 'numerical' || type === 'date') {
						saveTempComparisonValues(filter);
					} else if (type === 'string' || type === 'demandSimulation') {
						tempString = leanFilterService.getValue(filter);
					}
				}, 0);
			} else {
				resetViewValues();
				$timeout(function() {
					applied = false;
				}, 0);
			}
		}

		function cancelSelection() {
			if (viewValues.visibleMenu !== 'top') {
				var type = leanFilterService.getTypeOfFilter(viewValues.visibleMenu);
				if (type === 'multiselect') {
					var filt = leanFilterService.getFilterById(viewValues.visibleMenu);
					filt.objectList = tempList;
				} else if (type === 'numerical' || type === 'date') {
					leanFilterService.setComparator(viewValues.visibleMenu, tempComparator);
					leanFilterService.setValueOne(viewValues.visibleMenu, tempValueOne);
					leanFilterService.setValueTwo(viewValues.visibleMenu, tempValueTwo);
					if (leanFilterService.isCustomFilter(viewValues.visibleMenu)) {
						leanFilterService.setValue(viewValues.visibleMenu, tempString);
					}
				} else if (type === 'string' || type === 'demandSimulation') {
					leanFilterService.setValue(viewValues.visibleMenu, tempString);
				}
				leanFilterService.updateActiveFilters();
			}
			viewValues.visibleMenu = 'top';
		}

		function getApplied() {
			return applied;
		}

		function setApplied(val) {
			applied = val;
		}

		function applySelectionInner($event, callback, filterId, usingReduxStore, reportName, reportSettingsId) {
			applied = true;
			var type = leanFilterService.getTypeOfFilter(viewValues.visibleMenu);
			if (filterId && filterId === 'myItemsOnly') {
				viewValues.visibleMenu = 'myItemsOnly';
			} else {
				if (type === 'numerical' || type === 'date' || type === 'string' || type === 'demandSimulation') {
					angular.forEach(leanFilterService.activeFilters, function(af) {
						if (af.id === viewValues.visibleMenu && !_.includes(['string', 'demandSimulation'], type)) {
							leanFilterService.setComparator(viewValues.visibleMenu, af.comparator);
							leanFilterService.setValueOne(viewValues.visibleMenu, af.valueOne);
							leanFilterService.setValueTwo(viewValues.visibleMenu, af.valueTwo);
							if (leanFilterService.isCustomFilter(viewValues.visibleMenu)) {
								leanFilterService.setValue(viewValues.visibleMenu, af.value);
							}
						} else if (af.id === viewValues.visibleMenu) {
							leanFilterService.setValue(viewValues.visibleMenu, af.value);
						}
					});
				}
			}

			if (usingReduxStore && (!isReadOnly() || storeService.getState().reportSettings.childReportSettingsId)) {
				storeService.updateFilterSettings(leanFilterService.getFilterById(viewValues.visibleMenu), reportName, reportSettingsId);
			}

			// Do not change filter when filter is myItemsOnly
			if (filterId !== 'myItemsOnly') {
				if (viewValues.visibleMenu === 'factory' ||
					viewValues.visibleMenu === 'businessunit' ||
					viewValues.visibleMenu === 'division' ||
					viewValues.visibleMenu === 'entity') {
					leanFilterService.reloadFactoryFilters(usingReduxStore, false, true);
				} else {
					if (usingReduxStore) {
						leanFilterService.updateActiveFiltersRedux();
					} else {
						leanFilterService.updateActiveFilters();
					}
				}
			}

			callback(0, false, true, 'filtersChanged', filterId);
			if (filterId !== 'myItemsOnly') {
				var elem = $event.target.parentElement.parentElement;
				$timeout(function () {
					jQuery(elem.parentElement).click();
				}, 0);
			}
			viewValues.visibleMenu = 'top';
		}

		function sortFilters(filters, rangeFilters, stringFilters, singleSelectFilters) {
			if(!filters && !rangeFilters && !stringFilters && !singleSelectFilters) {
				return filters;
			}
			if(!filters) {
				filters = [];
			}
			var sorted = filters
				.concat(rangeFilters, stringFilters, singleSelectFilters)
				.filter(function(filter) {
					return filter && filter.displayName;
				})
				.map(function(filter) {
					return Object.assign(filter, { translatedDisplay: $translate.instant(filter.displayName)});
				})
				.sort(function(a,b) {
					return a.translatedDisplay.localeCompare(b.translatedDisplay);
				});

			return sorted;
		}

		function selectTopLevelFilter(filterId) {
			viewValues.visibleMenu = filterId;
			var type = leanFilterService.getTypeOfFilter(filterId);
			if (type === 'multiselect') {
				var list = leanFilterService.getList(filterId);
				saveTempList(list);
				updateAllOrNone(list);
			} else if (type === 'numerical' || type === 'date') {
				saveTempComparisonValues(filterId);
			} else if (type === 'string' || type === 'demandSimulation') {
				tempString = leanFilterService.getValue(filterId);
			}
		}

		function toggleItem(item, searchString, singleSelect) {
			var list = leanFilterService.getList(viewValues.visibleMenu);
			var comparisonKey = leanFilterService.getComparisonKey(viewValues.visibleMenu);
			angular.forEach(list, function (it) {
				if (it[comparisonKey] === item[comparisonKey]){
					if (singleSelect) {
						it.selected = true;
					} else {
						it.selected = !it.selected;
					}
				} else if (singleSelect) {
					it.selected = false;
				}
			});
			updateAllOrNone(list);
		}

		function removeFilterInner(filter, callback, usingReduxStore, reportName, reportSettingsId) {
			if(usingReduxStore) {
				storeService.dispatch({
					type: storeService.actions.FILTERS_DELETE_ONE,
					payload: {
						id: filter.id
					},
					meta: {
						reportName: reportName,
						reportSettingsId: reportSettingsId,
						userModified: true
					}
				});
			}
			if (filter.type === 'multiselect' || filter.type === 'singleSelect') {
				var list = leanFilterService.getList(filter.id);
				angular.forEach(list, function(item) {
					item.selected = false;
				});
			} else if (filter.type === 'numerical' || filter.type === 'date') {
				leanFilterService.setComparator(filter.id, undefined);
				leanFilterService.setValueOne(filter.id, '');
				leanFilterService.setValueTwo(filter.id, '');
				leanFilterService.setValue(filter.id, '');
			} else if (filter.type === 'string' || type === 'demandSimulation') {
				leanFilterService.setValue(filter.id, '');
			}
			if (filter.id === 'factory' ||
				filter.id === 'businessunit' ||
				filter.id === 'division' ||
				filter.id === 'entity') {
				leanFilterService.reloadFactoryFilters(usingReduxStore, false);
			} else {
				if (usingReduxStore) {
					leanFilterService.updateActiveFiltersRedux();
				} else {
					leanFilterService.updateActiveFilters();
				}
			}
			callback(0, false, true, 'filtersChanged', filter.id);
		}

		function clearAllFiltersInner(callback, usingReduxStore, reportName, reportSettingsId, defaultFilters) {
			var hasHierarchicalFilters = false;
			if (usingReduxStore) {
				storeService.dispatch({
					type: storeService.actions.FILTERS_DELETE_ALL,
					meta: {
						reportName: reportName,
						reportSettingsId: reportSettingsId,
						userModified: true
					}
				});
			}
			angular.forEach(leanFilterService.activeFilters, function(filter) {
				if (filter.type === 'multiselect' || filter.type === 'singleSelect') {
					var list = leanFilterService.getList(filter.id);
					angular.forEach(list, function(item) {
						item.selected = false;
					});
				} else if (filter.type === 'numerical' || filter.type === 'date') {
					leanFilterService.setComparator(filter.id, undefined);
					leanFilterService.setValueOne(filter.id, '');
					leanFilterService.setValueTwo(filter.id, '');
					leanFilterService.setValue(filter.id, '');
				} else if (filter.type === 'string' || type === 'demandSimulation') {
					leanFilterService.setValue(filter.id, '');
				}
				if (filter.id === 'factory' ||
					filter.id === 'businessunit' ||
					filter.id === 'division' ||
					filter.id === 'entity') {
					hasHierarchicalFilters = true;
				}
			});
			if (hasHierarchicalFilters) {
				leanFilterService.reloadFactoryFilters(usingReduxStore, false);
			} else {
				leanFilterService.updateActiveFilters();
			}
			if (usingReduxStore) {
				if (defaultFilters) {
					storeService.addDefaultFilters(defaultFilters, reportName, reportSettingsId);
					leanFilterService.updateActiveFiltersRedux(true);
				}
			}
			callback(0, false, true, 'filtersChanged');
		}

		function getViewValues() {
			return viewValues;
		}

		function getFilteredModel(fullModel, searchString) {
			var currentFilter = leanFilterService.getFilterById(viewValues.visibleMenu);
			var fieldName = currentFilter.label;

			var searchObject = {};
			searchObject[fieldName] = searchString;

			return $filter('filter')(fullModel, searchObject);
		}

		function toggleMyItem() {
			leanFilterService.myItemFilter.selected = !leanFilterService.myItemFilter.selected;
			leanFilterService.updateFiltersDependsOnMyItemFilter();
		}

		function isReadOnly() {
			return storeService.getState().reportSettings.readOnly;
		}

		function getNumberOfSaves() {
			return storeService.getState().reportSettings.numberOfSaves || 0;
		}

		function getReportAuthorizationLevel() {
			return storeService.getState().reportSettings.authorizationLevel;
		}
	}
})();
